export const ADDRESS_STORE_NAME = 'Address'
